export const CFO_WORKBOOK_WRITER = 'cfo-writer-300bdb755da5c5506115e1c7c8c7747fbc330bc18022f019dcebe8889fa05ade'
